function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'black': 'rgb(17, 17, 17)','navy': 'rgb(19, 34, 87)','blue': 'rgb(0, 116, 217)','aqua': 'rgb(127, 219, 255)','teal': 'rgb(57, 204, 204)','olive': 'rgb(128, 128, 0)','green': 'rgb(46, 204, 64)','lime': 'rgb(1, 255, 112)','yellow': 'rgb(255, 220, 0)','orange': 'rgb(255, 133, 27)','red': 'rgb(255, 65, 54)','fuchsia': 'rgb(240, 18, 190)','purple': 'rgb(177, 13, 201)','maroon': 'rgb(133, 20, 75)','silver': 'rgb(221, 221, 221)','gray': 'rgb(170, 170, 170)','white': 'rgb(255, 255, 255)','pink': 'rgb(250, 190, 190)','brown': 'rgb(154, 99, 36)','mint': 'rgb(170, 255, 195)','lavender': 'rgb(230, 190, 255)','blue': 'rgb(28, 74, 236)','tan': 'rgb(160, 78, 59)','cognac': 'rgb(161, 87, 50)','indigo': 'rgb(45, 46, 51)','military': 'rgb(118, 105, 82)','charcoal': 'rgb(101, 97, 104)','teal': 'rgb(27, 129, 133)','french': 'rgb(103, 109, 141)',};

    this.images = {'camo': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/camo_120x.png?v=3025673521901522850")','humbug': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/humbug_120x.png?v=8304206409783722326")','blue-red': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/blue-red_120x.png?v=17285960624533486049")','marl': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/marl_120x.png?v=14927297648157569024")','oxblood': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/oxblood_120x.png?v=14678527024736649919")','railroad': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/railroad_120x.png?v=1504535168504644488")','washed-indigo': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/washed-indigo_120x.png?v=17788621630578781200")','washed-denim': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/washed_120x.png?v=16622663643698722451")','yellow-green': 'url("//venue-theme-morning.myshopify.com/cdn/shop/files/yellow-green_120x.png?v=14158747982018122132")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
